import { Page } from "./page";


export
{
    Page
};

